var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 13,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m7 10.014 3.447 2.08a.335.335 0 0 0 .5-.36l-.913-3.92 3.04-2.634a.335.335 0 0 0-.194-.586l-4.006-.34L7.307.56a.332.332 0 0 0-.613 0L5.127 4.254l-4.007.34a.334.334 0 0 0-.186.586l3.04 2.634-.914 3.92a.335.335 0 0 0 .5.36z",
  clipRule: "evenodd"
})));
export default SvgStar;